import React from 'react';
import {Link, BrowserRouter, Route} from 'react-router-dom'
import './App.css';
import menuLogo from './img/brasao.jpg'
import Home from './pages/Home/Home'
import Cultura from './pages/area-cultura/Cultura'

function App() {
  return (
    <BrowserRouter basename="/espaco-cultural">
      <div id="menu">
        <a className="logo" href="http://www2.itanhaem.sp.gov.br/">
          <img src={menuLogo}/>
        </a>
        <div className="v-divisor" />
        <span>ESPAÇO CULTURAL</span>
        <div className="v-divisor" />
        <div className="menu-container">
          <Link to="/" className="menu-link">Home</Link>
          <Link to="/cultura" className="menu-link">Área da Cultura</Link>
          <a className="menu-link" href="http://www2.itanhaem.sp.gov.br/">Voltar a página inicial</a>
        </div>
      </div>
      <Route component={Home} path="/" exact/>
      <Route component={Cultura} path="/cultura"/>
    </BrowserRouter>
  );
}

export default App;
